import { featureFlagRoute } from './feature-flags'

export const allFeatureFlagRoutes = [featureFlagRoute()]
